import * as tslib_1 from "tslib";
import React from 'react';
import { Field } from 'formik';
import Input from '../../Input';
import { MODAL_TAB_INDEX_BASE } from '../tabIndexes';
var PollQuestionField = /** @class */ (function (_super) {
    tslib_1.__extends(PollQuestionField, _super);
    function PollQuestionField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PollQuestionField.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, onChange = _a.onChange;
        return (React.createElement(Field, { name: name, autoComplete: "off", render: function (_a) {
                var field = _a.field, form = _a.form;
                return (React.createElement("div", null,
                    React.createElement(Input, { value: field.value, name: field.name, onBlur: field.onBlur, label: label, onChange: onChange, error: form.touched.question && form.errors.question, errorMessage: form.touched.question && form.errors.question, maxLength: 120, tabIndex: MODAL_TAB_INDEX_BASE })));
            } }));
    };
    return PollQuestionField;
}(React.Component));
export default PollQuestionField;
//# sourceMappingURL=PollQuestionField.js.map